import { Component, inject, Input, TemplateRef, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ApiService, AuthService, EventsService, PusherService, UtilService, VariablesService } from 'src/app/shared/services';
import { Location, NgClass, NgFor, NgIf } from '@angular/common';
import { IUser } from 'src/app/shared/models';
import { ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { CurrencyIconPipe } from 'src/app/shared/pipes/currency-icon/currency-icon.pipe';
import { environment } from 'src/environments/environment';
import { API_URLS } from 'src/environments/api-urls';
import { Subscription } from 'rxjs';
import { SigninSignupComponent } from '../signin-signup/signin-signup.component';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-bill-pay-pitch',
  standalone: true,
  imports: [NgIf, NgFor, NgClass, MatDialogModule, MatRippleModule, CurrencyIconPipe, MatButtonModule, SigninSignupComponent, SharedModule],
  templateUrl: './bill-pay-pitch.component.html',
  styleUrls: ['./bill-pay-pitch.component.scss']
})
export class BillPayPitchComponent {

  private readonly actRoute = inject(ActivatedRoute);
  private readonly api = inject(ApiService);
  private readonly authService = inject(AuthService);
  private readonly dialog = inject(MatDialog);
  private readonly events = inject(EventsService);
  private readonly location = inject(Location);
  private readonly pusher = inject(PusherService);
  private readonly util = inject(UtilService);
  public readonly vars = inject(VariablesService);

  @ViewChild('billPayScreen', { static: false }) billPayScreenTemplate!: TemplateRef<any>;
  // @ViewChild('setuScreen', { static: false }) setuScreenTemplate!: TemplateRef<any>;
  @Input() type: 'full' | 'short' = 'full';
  @Input() position = '';

  text = {
    title: '',
    subTitle: ''
  };

  typText = {
    title: 'Bill Payment Unsuccessful!',
    subTitle: 'Your payment couldn’t go through due to an issue with your bank account'
  }

  userData: IUser;
  dialogRef: MatDialogRef<any>;
  // setuDialogRef: MatDialogRef<any>;
  params: any;
  currency = '';
  paidAmount = 0;
  isPaymentSuccess = false;
  isLoading = false;
  screenStep = 0; // 3 = typ
  loginPopupState = false;
  isPusherRecieved = false;
  isGifCompleted = false;
  bbpsUrl = '';
  pusherTimestamp = 0;
  newWindowRef: any;

  subs: Subscription[] = [];

  ngOnInit() {
    console.log(this.position);
    this.subs.push(
      this.vars.userData.subscribe(u => {
        this.userData = u;
        // this.userData.is_onboarded.setu = false;
      }),
      this.actRoute.queryParams.subscribe({
        next: (p: any) => {
          if ((this.position === p?.pos) || !p?.paystep) {
            this.handleQueryParams(p);
          }
        }
      })
    );
  }

  handleQueryParams(params: any) {
    this.params = { ...params };
    if (this.params?.paystep) {
      this.updateScreenStateFromParams();
      setTimeout(() => this.openDialog(), 10);
    } else {
      this.resetScreenState();
    }
  }

  updateScreenStateFromParams() {
    this.screenStep = +this.params?.paystep;
    this.currency = this.params?.transaction_currency || '';
    this.paidAmount = this.params?.transaction_amount || '';
    this.isPaymentSuccess = this.params?.transaction_status === 'true';
  }

  resetScreenState() {
    this.screenStep = 0;
    this.dialogRef?.close();
  }

  payBill() {
    this.isGifCompleted = false;
    this.sendSysEvent({ eventName: 'Card Clicked BBPS', info_1: this.userData?.is_onboarded?.setu ? 'Repeat User' : 'First time User' });
    if (this.userData?.is_onboarded?.setu && this.screenStep !== 3) {
      this.initBbps();
      return;
    }
    ++this.screenStep;
    this.openDialog();
    this.util.router.navigate([], { queryParams: { paystep: 1, pos: this.position }, queryParamsHandling: 'merge' });
  }

  openDialog() {
    this.setText();
    if (this.vars.isBbpsPopupOpen) {
      return;
    }
    this.vars.isBbpsPopupOpen = true;
    this.dialogRef = this.dialog.open(this.billPayScreenTemplate, {
      panelClass: 'billPaySreenDialog',
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      closeOnNavigation: false
    });
    this.dialogRef.afterClosed().subscribe(() => {
      this.vars.isBbpsPopupOpen = false;
    });
  }

  setText() {
    if (this.screenStep === 1) {
      this.text = {
        title: '<div>Pay Any Bill,</div> <div>Anytime</div>',
        subTitle: 'From electricity to internet, pay all your bills right here—fast and hassle-free'
      }
    } else if (this.screenStep === 2) {
      this.text = {
        title: 'Make a Difference with Every Payment',
        subTitle: '<div>Every bill you pay helps someone in need.</div> <div>Do good without spending more!</div>'
      }
    }
  }

  nextStep() {
    if (this.screenStep === 1) {
      this.isGifCompleted = false;
      this.sendSysEvent({ eventName: 'Onboarding BBPS', info_1: 'Step1 Complete' });
      ++this.screenStep;
      this.setText();
      this.util.router.navigate([], { queryParams: { paystep: 2 }, queryParamsHandling: 'merge' });
      return;
    }
    if (this.screenStep === 2) {
      this.initBbps();
      return;
    }
  }

  goBack() {
    this.isGifCompleted = false;
    --this.screenStep;
    this.setText();
    if (this.screenStep === 0) {
      this.resetScreenState();
    }
    this.location.back();
  }

  close() {
    this.resetScreenState();
    const qParams = {
      paystep: null,
      pos: null,
      transaction_status: null,
      transaction_currency: null,
      transaction_amount: null
    };
    this.util.router.navigate([], { queryParams: qParams, queryParamsHandling: 'merge' });
  }

  signinClosed(event) {
    this.userData = this.vars.userData.getValue();
    this.loginPopupState = false;
    if (this.userData?.verified_phone_number) {
      this.initBbps();
    }
  }

  initBbps() {
    if (!this.userData?.verified_phone_number) {
      this.loginPopupState = true;
      this.sendSysEvent({ eventName: 'Onboarding BBPS', info_1: 'phone verify start' });
      return;
    }
    if (!this.userData?.is_onboarded?.setu) {
      this.sendSysEvent({ eventName: 'Onboarding BBPS', info_1: 'Step2 Complete' });
    }
    this.isLoading = true;
    this.api.get(API_URLS.SETU_INIT(this.userData.id)).subscribe({
      next: res => {
        if (res?.data?.link) {
          this.bbpsUrl = res?.data?.link;
          this.openBbpsWindow();
        }
      },
      error: err => {
        console.error(err);
        this.util.openSnackBar('Failed to initialize BBPS. Please try again.', 'error');
        this.isLoading = false;
      }
    });
  }

  sendSysEvent(eData: { eventName: string, info_1: string, info_2?: string }) {
    if (this.position) {
      eData.info_2 = this.position;
    }
    this.events.sendSystemEvent(eData).subscribe(_ => _);
  }

  openBbpsWindow() {
    this.isLoading = false;
    // this.setuDialogRef = this.dialog.open(this.setuScreenTemplate, {
    //   panelClass: 'setuDialog',
    //   width: '100%',
    //   maxWidth: '100%'
    // });
    // const w = window.screen.width;
    // const h = window.screen.height;
    // this.newWindowRef = window.open(this.bbpsUrl, '_blank', `width=${w},height=${h},scrollbars=yes`);
    // console.log('newWindowRef = ', this.newWindowRef);
    // if (!this.newWindowRef) { return; }
    this.util.nativeNavigation(this.bbpsUrl, true);
    this.util.router.navigate([], { queryParams: { setu: 1 }, queryParamsHandling: 'merge' });
    this.pusherTimestamp = (new Date()).getTime();
    this.pusher.activateBBPSPusher(this.userData.id, this.pusherTimestamp);
    this.subs.push(this.vars.bbpsPusherRes.subscribe(res => {
      if (res?.pusherId !== this.pusherTimestamp) return;
      console.log(res);
      if (this.isPusherRecieved || res?.pg_used !== 'setu') { return; }
      this.isPusherRecieved = true;
      this.currency = res?.currency || '';
      this.paidAmount = Number(res?.amount) || 0;
      if (res?.transaction_return_status == 200) {
        this.typText = {
          title: 'Bill Payment Successful!',
          subTitle: 'Your payment is complete, and a donation has been made in your name'
        }
        this.actionAfterPusher(true);
      } else if (res?.failue_reason) {
        this.actionAfterPusher(false);
      }
    }));
  }

  actionAfterPusher(state: boolean) {
    this.close();
    // this.isPaymentSuccess = state;
    // this.isLoading = false;
    // // this.newWindowRef?.close();
    // // this.setuDialogRef.close();
    // this.screenStep = 3;
    // this.openDialog();
    // this.util.router.navigate([], { queryParams: { setu: null, paystep: 3, transaction_status: this.isPaymentSuccess, transaction_currency: this.currency, transaction_amount: this.paidAmount }, queryParamsHandling: 'merge' });
  }

  // me api call
  async getUpdatedUserData() {
    return new Promise((resolve, reject) => {
      this.authService.getUserProfile().subscribe({
        next: (res: any) => {
          if (!res?.data?.phone_1 && this.vars.userPhoneNumber) {
            res['data']['extension'] = this.vars.userPhoneExt;
            res['data']['phone_1'] = this.vars.userPhoneNumber;
          }
          this.util.setUserData(res.data);
          this.vars.userData.next(res.data);
          resolve(true);
        },
        error: (err) => {
          reject(false);
        }
      });
    });
  }

  goToDonation() {
    if (this.util.isBrowser) {
      const url = `${environment.sipretention_domain}/mydonations?redirect_url=${encodeURIComponent(window.location.href)}`;
      this.util.nativeNavigation(url);
    }
  }

  onGifLoad(): void {
    setTimeout(() => {
      this.isGifCompleted = true;
    }, 1200);
  }

  ngOnDestroy() {
    this.subs.forEach(s => s?.unsubscribe());
    this.dialogRef?.close();
    this.vars.isBbpsPopupOpen = false;
  }
}
